import { WorkflowTab } from '@/app/workflows/utils/navigation';
import { Tabs } from '@mantine/core';
import classes from '@/app/workflows/components/v6/atoms/tabs.module.css';
import { OnboardingFlows } from '@/app/contexts/OnboardingContext/constants';

interface WorkflowTabsUncontrolledProps {
  onChange: (value: string | null) => void;
  value: WorkflowTab;
}

export function WorkflowTabsControlled({ onChange, value }: WorkflowTabsUncontrolledProps) {
  return (
    <Tabs value={value} onChange={onChange} classNames={classes} id={`${OnboardingFlows.PRESET_MODAL}-0`}>
      <Tabs.List>
        <Tabs.Tab value={WorkflowTab.ALL}>All Presets</Tabs.Tab>
        <Tabs.Tab value={WorkflowTab.GENERAL}>General</Tabs.Tab>
        <Tabs.Tab value={WorkflowTab.APPLICATION}>Application</Tabs.Tab>
        <Tabs.Tab value={WorkflowTab.DEVICE}>Device</Tabs.Tab>
        <Tabs.Tab value={WorkflowTab.CUSTOM}>My Presets</Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
